import { designationOptions } from "../../options/designationOptions.js";

const LABEL_BY_ENUM_VALUE: Record<string, string> = Object.fromEntries(
  designationOptions.map((o) => [o.value, o.label]),
);

export function getDesignationDisplayLabel(code: string | undefined | null): string {
  if (code == null || String(code).trim() === "") return "—";
  const normalized = String(code).trim().toUpperCase().replace(/\s+/g, "_");
  if (LABEL_BY_ENUM_VALUE[normalized]) return LABEL_BY_ENUM_VALUE[normalized];
  const raw = String(code).trim();
  if (LABEL_BY_ENUM_VALUE[raw]) return LABEL_BY_ENUM_VALUE[raw];
  return raw.replace(/_/g, " ");
}
